import React from "react";
import useLoadImage from "../../../../../hooks/useLoadImage";
import { S3 } from "../../../../../constants";

const Photo = ({ src, className, onClickFunction }) => {
  const imgSrc = useLoadImage({ src });
  return (
    <>
      {imgSrc ? (
        <img
          src={S3.toCDN(imgSrc)}
          className={className}
          onClick={onClickFunction}
          loading="lazy"
        />
      ) : (
        <div className={className}></div>
      )}
    </>
  );
};

export default Photo;
